import { type HTMLAttributes } from "react";
import { cn } from "@/lib/cn.js";

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <div
      className={cn(
        "rounded-md bg-[linear-gradient(90deg,hsl(var(--muted))_0%,hsl(var(--muted-foreground)/0.10)_50%,hsl(var(--muted))_100%)] bg-[length:200%_100%] animate-shimmer",
        className
      )}
      {...props}
    />
  );
}
